import { attributes } from "@type-r/models";
import { Button, Column, Columns, div, FormSelect, Input, Loading, Option, PopupDialog, PrimaryButton } from "lqx-react"
import React, { useMemo } from "react"
import { useCollection, useIO, useLinked, useModel } from '@type-r/react';
import { BuyersLabel } from "./shared";
import { styled } from "@material-ui/core";
import { Company } from "../../../api/company";

const SearchModel = attributes({
    name: String,
    country: String,
    duns: String,
});

export const PolicyBuyerSearchForm = ({ $selectedSearchBuyer }) => {
    const searchModel = useModel(SearchModel);
    const $isPopupOpen = useLinked(false);
    const $isSelectOpen = useLinked(false);
    const companies = useCollection.of(Company);
    const $selectedCompanyId = useLinked(null);

    const filteredCompanies = useMemo(() => {
        return companies.models.filter(company =>
            (searchModel.duns && company.duns && company.duns.indexOf(searchModel.duns) >= 0) ||
            (searchModel.name && company.name && company.name.toLowerCase().indexOf(searchModel.name.toLowerCase()) >= 0)
        );
    }, [ companies[ '_changeToken' ], searchModel[ '_changeToken' ] ]);

    const $doSearchIO = useLinked(false);
    const isSearchReady = useIO(
        async () => $doSearchIO.isTruthy && await search(),
        [ $doSearchIO.value ]
    );

    const search = async () => {
        try {
            if (companies.models.length <= 0)
                await companies.fetch()
        } finally {
            $doSearchIO.set(false);
        }
        $isPopupOpen.set(true);
        $isSelectOpen.set(true);
    }

    const onOk = () => {
        $isPopupOpen.set(false);
        const matchingCompany = filteredCompanies.filter(c => c.id === $selectedCompanyId.value);
        $selectedSearchBuyer.set(matchingCompany.length > 0 ? matchingCompany[0] : null);
    }

    return isSearchReady ? <>
        <SearchTitle>Search for a buyer by name or DUNS #</SearchTitle>
        <Columns>
            <Column><BuyersLabel>Name</BuyersLabel></Column>
            <Column><BuyersLabel>Country</BuyersLabel></Column>
        </Columns>
        <Columns>
            <Column>
                <Input $value={ searchModel.$.name } />
            </Column>
            <Column>
                <FormSelect $value={ searchModel.$.country } >
                    <Option value="United States">United States</Option>
                    <Option value="United States">United States</Option>
                </FormSelect>
            </Column>
        </Columns>
        <Or>-- or --</Or>
        <Columns>
            <Column><BuyersLabel>Duns #</BuyersLabel></Column>
        </Columns>
        <Columns>
            <Column>
                <Input $value={ searchModel.$.duns } />
            </Column>
        </Columns>
        <Columns>
            <Column>
                <SearchButton color="primary" onClick={ $doSearchIO.true }>Search</SearchButton>
            </Column>
            <Column></Column>
        </Columns>

        { $isPopupOpen.value &&
            <PopupDialog
                title="SELECT CORPORATE BUYER"
                actions={
                    <>
                        <Button onClick={ $isPopupOpen.false }>Cancel</Button>
                        <PrimaryButton onClick={ onOk }>Ok</PrimaryButton>
                    </>
                }
            >
                <FormSelect $value={ $selectedCompanyId } { ...
                    {
                        open: $isSelectOpen.value,
                        onClose: () => $isSelectOpen.set(false),
                        onOpen: () => $isSelectOpen.set(true)
                    } }>
                    { filteredCompanies.map(company => <Option key={ company.cid } value={ company.id }>{ company.name }</Option>) }
                </FormSelect>
            </PopupDialog>
        }
    </> : <Loading />
}

const SearchButton = styled(Button)({
    marginTop: '20px',
    // backgroundColor: '#4197d6',
    // color: 'white'
});

const SearchTitle = div({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '13px',
    lineHeight: '15px',
    paddingTop: '10px',
    paddingBottom: '15px',
    paddingLeft: '15px',
});

const Or = div({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontSize: '12px',
    lineHeight: '15px',
    paddingTop: '10px',
    padding: '30px'
});